import React from "react";
import { Table } from "reactstrap";

import ShellCard from "components/ShellCard";

import { fmtInt, labelSituacao } from "../../ConferenciaFatura/formatters";
import { fmtMinutos } from "./formatos";
import renderEstadoSecao from "./EstadoSecao";

const EYEBROW = "Onde o tempo fica";
const TITULO = "Tempo por situação dentro da auditoria";
const DESCRICAO =
  "Quanto tempo a fatura passa em cada etapa, somando todas as passagens (um estorno faz a fatura voltar para A Validar e o tempo soma de novo). As seis situações aparecem sempre, mesmo zeradas.";

/**
 * Seção da H2 (PO1-3000): a quebra por situação do MESMO resumo consumido pela
 * JanelaAuditoria — um endpoint só, duas leituras.
 */
export default function TempoPorSituacao({ estado }) {
  const bloqueio = renderEstadoSecao(estado, "Sem faturas na coorte do período.");

  return (
    <ShellCard eyebrow={EYEBROW} title={TITULO} description={DESCRICAO}>
      {bloqueio || (
        <div className="lt-table-wrap">
          <Table className="lt-table" responsive>
            <thead>
              <tr>
                <th>Situação</th>
                <th className="lt-num">Faturas</th>
                <th className="lt-num">Média</th>
                <th className="lt-num">Mediana</th>
                <th className="lt-num">P90</th>
                <th className="lt-num">Máximo</th>
              </tr>
            </thead>
            <tbody>
              {estado.data.porSituacao.map((s) => (
                <tr key={s.codigo} className={s.faturas ? "" : "is-vazia"}>
                  <td>{labelSituacao(s.codigo, s.nome)}</td>
                  <td className="lt-num">{fmtInt(s.faturas)}</td>
                  <td className="lt-num">{fmtMinutos(s.mediaMin)}</td>
                  <td className="lt-num">{fmtMinutos(s.medianaMin)}</td>
                  <td className="lt-num">{fmtMinutos(s.p90Min)}</td>
                  <td className="lt-num">{fmtMinutos(s.maxMin)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </ShellCard>
  );
}
